<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createBrand.show()"
          v-if="role_modules.some(item => item.value == 'brand.create')"
        >
          <i class="uil-plus mr-1"></i> {{$t('currency.action.create_record')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
        <Table
          ref="list"
          :useView="role_modules.some(item => item.value == 'brand.view')"
          :useEdit="role_modules.some(item => item.value == 'brand.edit')"
          :params="params"
          noTitle
          :fields="fields"
          :action="role_modules.some(item => item.value == 'brand') ? action : false"
          @openFormBar="openFormBar"
        />
      <!-- <DataTable ref="brandTable"/> -->
      </div>
    </div>
    <Dialog
      customBtnClass="component-master-files"
      id="update_brand"
      centered
      autoload
      title="Update Brand"
      ref="editBrand"
      size="md"
      yesText="Update"
      noText="Cancel"
      :buttonDisable="updated"
      :component="editComponent"
      :parameters="{ brandID, submitted }"
      @onYes="onUpdateBrand"
      v-if="role_modules.some(item => item.value == 'webcrawler.edit')"
    />
    <Dialog
      customBtnClass="component-master-files"
      id="create_brand"
      centered
      autoload
      is_reset_model
      title="Create Brand"
      ref="createBrand"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="onCreateBrand"
      v-if="role_modules.some(item => item.value == 'webcrawler.create')"
    />
    <Dialog
      centered
      title="View Brand"
      ref="viewBrand"
      size="md"
      :component="viewComponent"
      :parameters="{ brandID, submitted }"
      v-if="role_modules.some(item => item.value == 'webcrawler.view')"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import moment from 'moment/moment'
import Dialog from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import ViewComponent from './components/dialogs/view.vue'
import EditComponent from './components/dialogs/edit.vue'

import error from '@utils/error'
// import DataTable from '@pages/brand/table'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    createComponent() {
      return CreateComponent
    },
    viewComponent() {
      return ViewComponent
    },
    editComponent() {
      return EditComponent
    },
  },
  data () {
    return {
      fields: [
				{
          label: this.$t('brand.table.name'), 
          key:"name",
          sortable: true
        },
        {
          label: this.$t('brand.table.date_created'), 
          key:'date_created', formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'brand/pagination',
      brandID: '',
      submitted: false,
      created: false,
      updated: false,
    }
  },
  methods: {
    onCreateBrand(val){
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      if (model && model.file) {
        let data = model
        model = new FormData()

        for (let key in data) {
          model.append(key, data[key])
        }
      }

      this.$store.dispatch('brand/create', model)
      .then(res => {
        if (res && res.data) {
          this.$refs.createBrand.hide();
          this.$refs.list.fetchData();
          this.submitted = !this.submitted;
          this.$bvToast.toast('Brand successfully created!', {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    openFormBar(id, editMode = false) {
      this.brandID = id
      if(!editMode){
        this.$refs.viewBrand.show()
      }else{
        this.$refs.editBrand.show()
      }
    },
    onUpdateBrand(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      let data = { ...model }

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      if (model && model.file) {
        model = new FormData()

        for (let key in data) {
          model.append(key, data[key])
        }
      }

      model.id = data._id ? data._id : data.id ? data.id : ''
      this.$store.dispatch('brand/update', model)
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          this.$refs.editBrand.hide();
          this.submitted = !this.submitted;
          this.$bvToast.toast('Brand successfully updated!', {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    }
  }
}
</script>